/*
DoubleIncCard.js
双增公式的卡片
 */
import React, {useEffect, useState} from "react";
import {Button, Card, Popconfirm} from "antd";
import {BlockMath} from "react-katex";
import {HolderOutlined, HighlightOutlined, DeleteOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {Textfit} from 'react-textfit';

import {updateDoubleCardInfo} from "../../../Model/DoubleIncIndexedDB/DoubleIncIndexedDB";

const {Meta} = Card;
// 默认的双增公式
const formula = `\\frac{(t_{2}+273.15)^{2}-(293.15)^{2}}{(t_{1}+273.15)^{2}-(293.15)^{2}}=\\textcolor{red}K \\frac{(t_{2}+273.15)^{2}}{(t_{1}+273.15)^{2}}`;

const DoubleIncCard = ({id, card, setIsEditingDrawerOpen, setDrawerCardID, handleRefreshCards}) => {
    // 是否光标覆盖
    const [hovered, setHovered] = useState(false);
    // 标题
    const [cardTitle, setCardTitle] = useState(`卡片${id}`);
    // 备注
    const [cardDescription, setCardDescription] = useState('备注');
    // 双增公式
    const [cardFormula, setCardFormula] = useState(formula);

    useEffect(() => {
        setCardTitle(card.title);
        setCardDescription(card.description);
        let t1 = card.T1;
        let t2 = card.T2;
        let k = card.k === 'K' ? `K` : `(${card.k}\\%)`;
        // 设置公式
        switch (card.cal) {
            case 'T1':
                t1 = `\\textcolor{red}` + `{${t1}}`;
                break;
            case 'T2':
                t2 = `\\textcolor{red}` + `{${t2}}`;
                break;
            case 'k':
            case '-':
                k = `\\textcolor{red}` + `{${k}}`;
                break;
            default:
                console.log('no match');
        }
        setCardFormula(`\\frac{({${t2}}+273.15)^{2}-(293.15)^{2}}{({${t1}}+273.15)^{2}-(293.15)^{2}}={{${k}}} \\frac{({${t2}}+273.15)^{2}}{({${t1}}+273.15)^{2}}`)
    }, [card]);
    // 光标覆盖
    const handleMouseEnter = () => {
        setHovered(true);
    };

    // 光标离开
    const handleMouseLeave = () => {
        setHovered(false);
    };

    // 开启编辑Drawer
    const handleShowEditingDrawer = () => {
        setIsEditingDrawerOpen(true);
        setDrawerCardID(id);
    };

    // 清空卡片数据
    const handleClearConfirm = () => {
        updateDoubleCardInfo(id, `卡片${id}`, '备注', 't_{1}', 't_{2}',  'K', '-').then(() => {
            handleRefreshCards();
        })
    };

    return (
        <Card title={cardTitle}
              extra={<HolderOutlined/>}
              cover={
                  <div style={{width: '90%', margin: '0 auto'}}>
                      <Textfit mode="single">
                          <BlockMath math={cardFormula}/>
                      </Textfit>
                  </div>
              }
              bordered={true}
              actions={hovered && [
                  <Button type="text" icon={<HighlightOutlined/>} size='large' onClick={handleShowEditingDrawer}/>,
                  <Popconfirm title={'确定清空?'} description={`确定要清空${cardTitle}的内容吗？`} placement='top'
                              okText='清空' cancelText='取消' onConfirm={handleClearConfirm}
                              icon={<QuestionCircleOutlined style={{color: 'red',}}/>}>
                      <Button type="text" icon={<DeleteOutlined/>} size='large' danger/>
                  </Popconfirm>
              ]}
              style={{
                  transition: "box-shadow 0.3s",
                  boxShadow: hovered
                      ? "0 4px 12px rgba(0, 0, 0, 0.2)"
                      : "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}>
            <Meta description={cardDescription}/>
        </Card>
    );
};

export default DoubleIncCard;